import React, { useEffect, useState } from "react";
import "../styles/index.less";
import { Carousel, Col, Row, Button, Typography } from "antd";
import { DoubleRightOutlined, InboxOutlined } from "@ant-design/icons";
import { get_all_announcement } from "../../../services/announcement";

type Props = {};

const { Title } = Typography;

interface Announcement {
  colordetail: string;
  summarize: string;
  readMore: any;
  url: any;
  colorbutton: string;
  colortitle: string;
  textPosition: string;
  colorbackground: any;
  backcolor: any;
  detail: string;
  id: number;
  announcement_id: string;
  announcement_type: number;
  title: string;
  content: string; // เนื่องจาก content เป็น JSON string คุณสามารถ parse เพิ่มเติมได้ในภายหลัง
  created_date: string;
  img: string | null;
  link: string | null;
  created_by: string;
  status: number;
}

const CarouselCom = (props: Props) => {
  const [carouselData, setCarouselData] = useState<Announcement[]>([]);
  const [, forceUpdate] = useState({});

  // api get data show carousel
  useEffect(() => {
    getCarouselHome();
  }, []);

  // get annoucment
  const getCarouselHome = async () => {
    try {
      const res = await get_all_announcement();

      // กรองข้อมูลที่มี status === 1 ก่อน
      const activeAnnouncements = res.result.filter(
        (item: any) => item.status === 1
      );

      const parsedData = activeAnnouncements.flatMap((item: any) => {
        try {
          if (item.announcement_type === 1) {
            // ✅ กรณีประกาศแบบที่ 1 (มี content)
            const content = JSON.parse(item.content);
            const details = content[0]?.details || [];

            return details.map((detail: any) => ({
              ...detail,
              img: item.img,
              id: item.id,
              announcement_id: item.announcement_id,
            }));
          } else if (item.announcement_type === 2) {
            const image = item.img;
            const content = JSON.parse(item.content);
            const details = content[0]?.details || [];
            return details.map((detail: any) => {
              return {
                ...detail,
                img: image, // ใช้ img จาก detail
                id: item.id,
                announcement_id: item.announcement_id,
              };
            });
          }
        } catch (error) {
          console.error("Error parsing content:", item, error);
          return [];
        }
      });

      setCarouselData(parsedData); // ตั้งค่าข้อมูล carousel ที่กรองแล้ว
    } catch (e) {
      console.error("Error fetching carousel data:", e);
    }
  };

  return (
    // autoplay autoplaySpeed={10000}
    <div className="globalcontainer">
      {carouselData.length > 0 ? (
        <Carousel
          autoplay={carouselData.length > 1} // เปิด autoplay เมื่อมีมากกว่า 1 รายการ
          dots={carouselData.length > 1} // แสดงจุดนำทางเฉพาะเมื่อมีมากกว่า 1 รายการ
          arrows={carouselData.length > 1} // ซ่อนปุ่มลูกศรเมื่อมีเพียง 1 รายการ
          draggable={carouselData.length > 1} // ไม่ให้ลากสไลด์เมื่อมีเพียง 1 รายการ
        >
          {carouselData.map((item, index) => {
            return (
              <div key={item.id}>
                <Row
                  align="middle"
                  className="carouselmain"
                  style={{
                    background:
                      item.backcolor || item.colorbackground || "#FFFFFF",
                    border:
                      item.colorbackground || item.backcolor
                        ? "none"
                        : "1px solid #DADADA",
                    borderRadius: "10px",
                  }}
                >
                  {/* มีรูปภาพ */}
                  {item.img ? (
                    <>
                      {item.textPosition === "left" && (
                        <>
                          <Col span={12} className="carouselmainall">
                            <div
                              className="title-head"
                              style={{ marginTop: "0px" }}
                            >
                              <Title
                                level={3}
                                className="title-level-3-2"
                                style={{ color: item.colortitle || "#FFFFFF" }}
                              >
                                {item.detail || ""}
                              </Title>
                              <p
                                className="title-level-3-3"
                                style={{ color: item.colordetail || "#FFFFFF" }}
                              >
                                {item.summarize || ""}
                              </p>
                              {item.readMore && item.url && (
                                <Button
                                  type="link"
                                  className="button-banner"
                                  target="_blank"
                                  href={item.url}
                                  style={{
                                    backgroundColor:
                                      item.colorbutton || "#FFFFFF",
                                  }}
                                >
                                  Read More <DoubleRightOutlined />
                                </Button>
                              )}
                            </div>
                          </Col>
                          <Col span={12} className="carouselmainall">
                            <Row justify="center" align="middle">
                              <Col>
                              <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ display: "inline-block" }}
                            >
                                <img
                                  src={`${process.env.REACT_APP_API}${item.img}`}
                                  alt={`uploaded-${item.id}`}
                                  className="title-image"
                                />
                                </a>
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}

                      {item.textPosition === "right" && (
                        <>
                          <Col span={12} className="carouselmainall">
                            <Row justify="center" align="middle">
                              <Col>
                              <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ display: "inline-block" }}
                            >
                                <img
                                  src={`${process.env.REACT_APP_API}${item.img}`}
                                  alt={`uploaded-${item.id}`}
                                  className="title-image-right"
                                  // className="title-image" style={{ borderRadius: 20, height: 300 }}
                                />
                                </a>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={12} className="carouselmainall">
                            {/* <Row justify="center" align="middle"> */}
                            <div
                              className="title-head-right"
                              style={{ marginTop: "0px" }}
                            >
                              <Title
                                level={3}
                                className="title-level-3-2-right"
                                style={{ color: item.colortitle || "#FFFFFF" }}
                              >
                                {item.detail || ""}
                              </Title>
                              <p
                                className="title-level-3-3-right"
                                style={{ color: item.colordetail || "#FFFFFF" }}
                              >
                                {item.summarize || ""}
                              </p>
                              {item.readMore && item.url && (
                                <Button
                                  type="link"
                                  className="button-banner-right"
                                  target="_blank"
                                  href={item.url}
                                  style={{
                                    backgroundColor:
                                      item.colorbutton || "#FFFFFF",
                                  }}
                                >
                                  Read More <DoubleRightOutlined />
                                </Button>
                              )}
                            </div>
                            {/* </Row> */}
                          </Col>
                        </>
                      )}

                      {item.textPosition === "center" && (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "inline-block",
                          }}
                        ><a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: "inline-block" }}
                      >
                          <img
                            src={`${process.env.REACT_APP_API}${item.img}`}
                            alt={`uploaded-${item.id}`}
                            className="title-image-center"
                          /></a>
                          <div
                            className="title-head"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              textAlign: "center",
                              color: "#fff",
                            }}
                          >
                            <Title
                              level={3}
                              className="title-level-3-2"
                              style={{ color: item.colortitle || "#FFFFFF" }}
                            >
                              {item.detail || ""}
                            </Title>
                            <p
                              className="title-level-3-3"
                              style={{ color: item.colordetail || "#FFFFFF" }}
                            >
                              {item.summarize || ""}
                            </p>
                            {item.readMore && item.url && (
                              <Button
                                type="link"
                                className="button-banner"
                                target="_blank"
                                href={item.url}
                                style={{
                                  backgroundColor:
                                    item.colorbutton || "#FFFFFF",
                                }}
                              >
                                Read More <DoubleRightOutlined />
                              </Button>
                            )}
                          </div>
                        </div>
                      )}

                      {/* ไม่มี textPosition */}
                      {!item.textPosition && item.img && (
                        <div
                          className="imageonposition"
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              // style={{ display: "inline-block" }}
                            >
                          <img
                            src={`${process.env.REACT_APP_API}${item.img}`}
                            alt={`uploaded-${item.id}`}
                            className="title-image"
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "10px",
                            }}
                          />
                          </a>
                          {item.readMore && item.url && (
                            <Button
                              type="link"
                              className="button-banner"
                              target="_blank"
                              href={(item as any).url}
                              style={{
                                position: "absolute",
                                bottom: "50px",
                                left: "30px",
                                backgroundColor:
                                  (item as any).colorbutton || "#FFFFFF",
                              }}
                            >
                              Read More <DoubleRightOutlined />
                            </Button>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {item.detail && item.summarize ? (
                        <>
                          {item.textPosition === "left" && (
                            <>
                              <Col span={12} style={{ paddingLeft: "50px" }}>
                                <div
                                  className="title-head"
                                  style={{
                                    paddingRight: "50px",
                                    marginTop: "0px",
                                  }}
                                >
                                  <Title
                                    level={3}
                                    className="title-level-3-2"
                                    style={{
                                      color: item.colortitle || "#FFFFFF",
                                    }}
                                  >
                                    {item.detail || ""}
                                  </Title>
                                  <p
                                    className="title-level-3-3"
                                    style={{
                                      color: item.colordetail || "#FFFFFF",
                                    }}
                                  >
                                    {item.summarize || ""}
                                  </p>
                                  {item.readMore && item.url && (
                                    <Button
                                      type="link"
                                      className="button-banner"
                                      target="_blank"
                                      href={item.url}
                                      style={{
                                        backgroundColor:
                                          item.colorbutton || "#FFFFFF",
                                      }}
                                    >
                                      Read More <DoubleRightOutlined />
                                    </Button>
                                  )}
                                </div>
                              </Col>
                              <Col span={12}></Col>
                            </>
                          )}

                          {item.textPosition === "right" && (
                            <>
                              <Col span={12}></Col>
                              <Col span={12} style={{ paddingLeft: "50px" }}>
                                <div
                                  className="title-head"
                                  style={{
                                    paddingRight: "50px",
                                    marginTop: "0px",
                                  }}
                                >
                                  <Title
                                    level={3}
                                    className="title-level-3-2"
                                    style={{
                                      color: item.colortitle || "#FFFFFF",
                                    }}
                                  >
                                    {item.detail || ""}
                                  </Title>
                                  <p
                                    className="title-level-3-3"
                                    style={{
                                      color: item.colordetail || "#FFFFFF",
                                    }}
                                  >
                                    {item.summarize || ""}
                                  </p>
                                  {item.readMore && item.url && (
                                    <Button
                                      type="link"
                                      className="button-banner"
                                      target="_blank"
                                      href={item.url}
                                      style={{
                                        backgroundColor:
                                          item.colorbutton || "#FFFFFF",
                                      }}
                                    >
                                      Read More <DoubleRightOutlined />
                                    </Button>
                                  )}
                                </div>
                              </Col>
                            </>
                          )}

                          {item.textPosition === "center" && (
                            <>
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  height: "100%",
                                  display: "inline-block",
                                }}
                              >
                                <div
                                  className="title-head"
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    textAlign: "center",
                                    color: "#fff",
                                  }}
                                >
                                  <Title
                                    level={3}
                                    className="title-level-3-2"
                                    style={{
                                      color: item.colortitle || "#FFFFFF",
                                    }}
                                  >
                                    {item.detail || ""}
                                  </Title>
                                  <p
                                    className="title-level-3-3"
                                    style={{
                                      color: item.colordetail || "#FFFFFF",
                                    }}
                                  >
                                    {item.summarize || ""}
                                  </p>
                                  {item.readMore && item.url && (
                                    <Button
                                      type="link"
                                      className="button-banner"
                                      target="_blank"
                                      href={item.url}
                                      style={{
                                        backgroundColor:
                                          item.colorbutton || "#FFFFFF",
                                      }}
                                    >
                                      Read More <DoubleRightOutlined />
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: "40px",
                              lineHeight: "400px",
                            }}
                          >
                            Preview
                          </div>
                          {item.readMore && item.url && (
                            <Button
                              type="link"
                              className="button-banner"
                              target="_blank"
                              href={item.url}
                              style={{
                                backgroundColor: item.colorbutton || "#FFFFFF",
                              }}
                            >
                              Read More <DoubleRightOutlined />
                            </Button>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </Row>
              </div>
            );
          })}

          {carouselData.length <= 1 && <Carousel></Carousel>}
        </Carousel>
      ) : (
        // <div
        //   style={{
        //     position: "relative",
        //     width: "100%",
        //     height: "100%",
        //   }}
        // >
        //   <div
        //     style={{
        //       textAlign: "center",
        //       fontSize: "20px",
        //       lineHeight: "400px",
        //     }}
        //   >
        //     ไม่มีข้อมูลประกาศ
        //   </div>
        // </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "400px",
            border: "1.5px solid #DADADA",
            borderRadius: "10px",
            // background: "#FAFAFA",
          }}
        >
          <InboxOutlined style={{ fontSize: "48px", color: "#C0C0C0" }} />
          <div style={{ marginTop: "12px", color: "#C0C0C0", fontSize: "18px" }}>
            No announcement available
          </div>
        </div>
      )}
    </div>
  );
};

export default CarouselCom;
